import LEGACY_ORG_FEATURES from '~/server_shared/generated-types/LEGACY_ORG_FEATURES';
import { isLegacyOrgFeatureEnabled } from '~/Utils';

export const isUserWithImplicitApprovalPermission = (user) => {
  // When altering this function, please also update the backend function: `is_user_with_implicit_approval_permission`
  return user.is_org_level_supervisor || user.is_manager;
};

export const getUserIdsWithImplicitApprovalPermission = (users) => {
  return users.filter((user) => isUserWithImplicitApprovalPermission(user)).map((user) => user.id);
};

/**
 * Whether record-only payments are available anywhere in this organization.
 *
 * Deliberately not `shouldEnableRecordOnly` from `usePaymentsConfiguration`: that one answers for a
 * single *current* payment method, defaulting to the first enabled one, which an organization-level
 * screen has no notion of -- it would hide the setting from an organization whose record-only method
 * simply is not first. This mirrors `isSwiftBicEnabledForAnyOfMethods`, which exists in that same
 * hook for exactly this "on for at least one enabled method" question. The MGM carve-out is taken
 * from the backend's `ManagedPaymentsConfiguration.enable_record_only`, which ORs in the same
 * `name == 'mgm'` test; that property resolves a single method, so only the carve-out is shared.
 *
 * @param {import('../types').PaymentsConfiguration} [paymentsConfiguration]
 * @param {{ name?: string }} [organization]
 * @returns {boolean}
 */
export const isRecordOnlyEnabledForOrg = (paymentsConfiguration, organization) =>
  Boolean(
    paymentsConfiguration?.payment_method_configurations?.some(
      (paymentMethodConfig) =>
        !paymentMethodConfig.is_disabled && paymentMethodConfig.method_configuration?.enable_record_only
    ) ||
      // Some legacy orgs get record-only on every method regardless of the per-method switch.
      isLegacyOrgFeatureEnabled(organization, LEGACY_ORG_FEATURES.MGM_FORCE_RECORD_ONLY_PAYMENTS)
  );
